<template>
  <div class="intro" >
    <div class="flash_content">
		<div class="image_container">
			<img class="flash_img" :src="require(`@/assets/images/bgImage_flash.png`)" alt="">
		</div>
		<div class="overlay">
			<img :src="require(`@/assets/images/logo.png`)" alt="">
			<button type="button" name="button"  @click.prevent="skipFlashPage">Enter Here</button>
		</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlashPage",
  props: ["skipFlashPage"],
};
</script>

<style lang="scss" scoped>
.intro {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
  background: theme-var($--ch-theme-primary);
 .flash_content{
	 position:relative;
	 .flash_img{

		 width:100%;
		 height: 100vh;
		 object-fit: cover;
		 object-position: center;
	 }
	 .overlay{
		 position:absolute;
		 top:50%;
		 left:50%;
		 transform: translate(-50%, -50%);
		 display: flex;
		 justify-content:center;
		 align-items: center;
		 flex-direction:column;
		 img{
			 width: 190px;
			 height: 190px;
		 }
		 button{
			margin-top: 50px;
			font-family: 'Verlag Condensed Book';
			font-style: normal;
			font-weight: 400;
			font-size: 25px;
			line-height: 100%;
			padding: 8px 60px;
			text-transform: uppercase;
			color: #FFFFFF;
			border: 1px solid #CC3433;
			background: #CC3433;
			border-radius: 55px;
			transition: all 0.3s ease 0s;
			&:hover{
				background: theme-var($--ch-theme-primary);
				border: 1px solid theme-var($--ch-theme-primary);
				transform: translateY(2px);
			}
		 }
	 }
 }
}
</style>
